import {ChangeDetectionStrategy, Component, Input, OnInit, ViewChild} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faPlay, faStar} from '@fortawesome/free-solid-svg-icons';
import {Shape} from 'app/blocks/model/enums/shape.enum';
import {IResourceIcon, ResourceIcon} from 'app/blocks/model/resource-icon.model';

@Component({
    // Angular 22 defaults to OnPush; Eager preserves the previous behaviour.
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'resource-icon',
    templateUrl: './resource-icon.component.html',
    styleUrls: ['./resource-icon.component.scss'],
    standalone: false
})
export class ResourceIconComponent {
    constructor() {}

    @Input() data: IResourceIcon;
    @Input() unpersistedStyleJson: string; //for display purposes, not saved to db
    @Input() useBigVersion: string;

    @ViewChild('fontawesomeicon') icon: FaIconComponent;

    public getIconStyle(isIcon = false) {
        if (!this.data) {
            return;
        }

        let styles: any = {};
        const isRgbColor = this.data.color.includes('rgb');
        const isCorrectlyFormattedHexColor = !isRgbColor && this.data.color.startsWith('#');

        const color = isRgbColor || isCorrectlyFormattedHexColor ? this.data.color : '#' + this.data.color;

        if (isIcon) {
            styles.color = color;
        } else {
            styles.backgroundColor = color;
        }
        return styles;
    }

    getColor(): string {
        if (!this.data) {
            return;
        }

        const isRgbColor = this.data.color.includes('rgb');
        const isCorrectlyFormattedHexColor = !isRgbColor && this.data.color.startsWith('#');

        const color = isRgbColor || isCorrectlyFormattedHexColor ? this.data.color : '#' + this.data.color;
        return color;
    }

    public getShapeClass(): string {
        if (!this.data) {
            return '';
        }

        let classSuffix = this.useBigVersion?.toLowerCase() == 'true' ? '-big' : '';

        switch (this.data.shapeId) {
            case Shape.CIRCLE:
                return `circle${classSuffix} resource-icon`;
            case Shape.SQUARE:
                return `square${classSuffix} resource-icon`;
            case Shape.DIAMOND:
                return `diamond${classSuffix} resource-icon`;
            case Shape.TRIANGLE:
                return `triangle${classSuffix} resource-icon`;
            case Shape.UPSIDEDOWN_TRIANGLE:
                return `upside-down-triangle${classSuffix} resource-icon`;
            case Shape.STAR:
                return `star${classSuffix} resource-icon`;
            default:
                return '';
        }
    }

    public useFontAwesome() {
        return this.data.shapeId > Shape.DIAMOND;
    }

    public getFontAwesomeIconName() {
        switch (this.data.shapeId) {
            case Shape.TRIANGLE:
                return faPlay;
            case Shape.UPSIDEDOWN_TRIANGLE:
                return faPlay;
            case Shape.STAR:
                return faStar;
        }
    }
}
